<template>
    <section ref="section2" class="mx-auto flex h-full flex-col">
        <v-register-head
            @previous="1"
            :step="2"
            :landing-route="registrationProcessData.routes.landing"
        ></v-register-head>
        <div
            class="flex h-full flex-col items-center justify-between px-4 py-8 md:px-12"
        >
            <form
                method="POST"
                :action="registrationProcessData.routes.processVerificationCode"
                id="submit-verification-code-form"
                class="flex h-full flex-col justify-between"
            >
                <v-csrf-token></v-csrf-token>
                <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                    <figure class="flex gap-3">
                        <div>
                            <v-icon icon="phone-verify" size="8"></v-icon>
                        </div>
                        <div class="flex flex-col justify-center">
                            <div class="mb-3 text-heading-3-desktop">
                                Vnesite 6-mestno verifikacijsko kodo
                            </div>
                            <div class="text-body-regular text-black-40">
                                Vpišite 6.mestno verifikacijsko kodo, ki smo vam
                                jo poslali na vašo telefonsko številko
                            </div>

                            <template v-if="session.error">{{
                                session.error
                            }}</template>
                        </div>
                    </figure>
                    <figure class="flex justify-between gap-3">
                        <v-form-input v-for="(input, index) in inputs"
                            :key="index"
                            :id="`verify-char-${index}`"
                            :name="`verifyChar${index + 1}`"
                            class="single-digit"
                            v-model="input.value"
                            :value="input.value"
                            label=" "
                            :force-hide-label="true"
                            @paste="handlePaste(index, $event)"
                            @input="handleInput(index)"
                            @keydown="handleKeydown(index, $event)"
                            :ref="`pinInput_${index}`"
                            type="number"
                        ></v-form-input>
                        <template
                            ><!-- TODO --></template
                        >
                    </figure>
                </figure>
                <figure
                    class="flex w-full max-w-lg flex-col items-center gap-3 lg:w-full"
                >
                    <a
                        class="button button--white h-[48px] px-6"
                        :href="
                            registrationProcessData.routes.resendVerificationSms
                        "
                    >
                        <label class="text-body-medium"
                            >Ponovno pošlji verifikacijsko kodo</label
                        >
                        <v-icon icon="reload" size="4"></v-icon>
                    </a>
                </figure>
            </form>
        </div>
        <div
            class="flex h-full max-h-[102px] justify-between border-t px-4 pt-4"
        >
            <div class="flex w-full justify-center">
                <a
                    @click="submitForm('submit-verification-code-form')"
                    class="button button--form"
                >
                    <label class="text-small-text-medium">Nadaljujte</label>
                    <v-icon icon="arrow-right" size="4"></v-icon>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        registrationProcessData: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        user: {
            type: Object,
            required: true,
        },
        session: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            inputs: Array.from({ length: 6 }, () => ({ value: '' })),
        };
    },
    computed: {},
    methods: {
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
        handlePaste(inputIndex, event) {
            const clip = event.clipboardData.getData('text');
            const sanitizedClip = clip.replace(/\s/g, "");
            const characters = [...sanitizedClip];

            characters.forEach((char, i) => {
                if (i < this.inputs.length) {
                    this.inputs[i].value = char;
                }
            });

            // Focus on the next input
            if (inputIndex < this.inputs.length - 1) {
                const nextInputRef = this.$refs[`pinInput_${inputIndex + 1}`][0]
                const nextInputInnerRef = nextInputRef.$refs.formInput.$el
                nextInputInnerRef.focus()
            }
        },

        handleInput(inputIndex) {
            // Handle typing, focus on the next input
            const currentInputRef = this.$refs[`pinInput_${inputIndex}`][0]
            const currentInputInnerRef = currentInputRef.$refs.formInput.$el

            if (inputIndex < this.inputs.length - 1 && currentInputInnerRef.value) {
                const nextInputRef = this.$refs[`pinInput_${inputIndex + 1}`][0]
                const nextInputInnerRef = nextInputRef.$refs.formInput.$el
                nextInputInnerRef.focus()
            }
        },

        handleKeydown(inputIndex, event) {
            const elInput = this.$refs[`pinInput_${inputIndex}`][0].$refs.formInput.$el

            if (!elInput.value && event.key === "Backspace" && inputIndex > 0) {
                // Handle deleting, focus on the previous input
                const previousInputRef = this.$refs[`pinInput_${inputIndex - 1}`][0]
                const previousInputInnerRef = previousInputRef.$refs.formInput.$el
                previousInputInnerRef.focus()
            }
        },

        appendSeperator() {
            // Append div between 3rd and 4th v-form-input
            const div = document.createElement("div");
            div.classList.add("flex", "items-center", "justify-center", "text-black-40");
            div.innerText = "-";
            this.$refs.pinInput_2[0].$el.after(div);
        }
    },
    
    mounted() {
        this.appendSeperator();
    }
};
</script>
